import { useMutation } from "@tanstack/react-query";
import { deleteContact } from "api";
import { toastEmitter } from "components/Toast";

export default function useDeleteContact({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  // const queryclient = useQueryClient();

  const Request = useMutation({
    mutationFn: deleteContact,
    mutationKey: ["deleteContact"],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter("error", responseData?.error?.message);
      }
      handleSuccess();
      // queryclient.invalidateQueries(["getMemberListing"]);
      toastEmitter("success", responseData?.data?.message);
    },
  });
  return { ...Request };
}
